import { useContext } from "react";
import { PortalSessionContext } from "./PortalSessionContext";
import type { PortalSessionState } from "./portalSessionStorage";

/**
 * Reads the shared portal-session state: the token, its setter and `clear`.
 * Throws outside a `PortalAuthProvider`, so a wiring mistake fails loudly.
 */
export function usePortalSession(): PortalSessionState {
  const ctx = useContext(PortalSessionContext);
  if (!ctx) {
    throw new Error("usePortalSession must be used within a PortalAuthProvider");
  }
  return ctx;
}
